/**
 * AI スタイリングコンシェルジュ フロントエンド
 * - 画像を canvas で最大768pxにリサイズ + WebP圧縮してからバックエンドへ送信(トークン/転送量削減)
 * - 提案結果をカード表示し、/cart/add.js でその場カート追加
 */
(function () {
  "use strict";

  var MAX_EDGE = 768;      // 長辺の最大px(画像トークン節約とビジョン精度のバランス)
  var WEBP_QUALITY = 0.8;

  var root = document.getElementById("ai-stylist");
  if (!root) return;
  var endpoint = root.dataset.endpoint;

  var dropzone = document.getElementById("ais-dropzone");
  var fileInput = document.getElementById("ais-file");
  var cameraInput = document.getElementById("ais-camera-file");
  var pickFileBtn = document.getElementById("ais-pick-file");
  var pickCameraBtn = document.getElementById("ais-pick-camera");
  var previewWrap = document.getElementById("ais-preview-wrap");
  var preview = document.getElementById("ais-preview");
  var changePhotoBtn = document.getElementById("ais-change-photo");
  var hint = document.getElementById("ais-hint");
  var occasionSel = document.getElementById("ais-occasion");
  var itemTypeSel = document.getElementById("ais-item-type");
  var submitBtn = document.getElementById("ais-submit");
  var submitLabel = submitBtn.querySelector(".ai-stylist__submit-label");
  var spinner = submitBtn.querySelector(".ai-stylist__spinner");
  var errorEl = document.getElementById("ais-error");
  var resultsEl = document.getElementById("ais-results");
  var commentEl = document.getElementById("ais-comment");
  var cardsEl = document.getElementById("ais-cards");
  var helpOverlay = document.getElementById("ais-help-overlay");
  var helpTitle = document.getElementById("ais-help-title");
  var helpBody = document.getElementById("ais-help-body");
  var helpClose = document.getElementById("ais-help-close");
  // テーマ側の祖先要素にtransform等が設定されていると position:fixed の基準点が
  // ビューポートではなくその祖先になってしまうため、bodyの直下に移動させて回避する
  if (helpOverlay && helpOverlay.parentNode !== document.body) {
    document.body.appendChild(helpOverlay);
  }

  var imageBase64 = null; // data:プレフィックスなしのWebP base64
  var imageMediaType = "image/webp";
  var STORAGE_KEY = "aisState";
  var eventEndpoint = endpoint ? endpoint.replace(/\/api\/stylist\/?$/, "/api/log") : null;

  // ---- アクセス解析(ページ表示・診断実行・カート追加・商品クリック・エラーをバックエンド経由でGASのスプレッドシートへ記録) ----
  var SESSION_STORAGE_KEY = "aisSessionId";
  var ADMIN_MODE_KEY = "aisAdminMode";

  // ?admin=1 を一度開くと以後このブラウザでは管理者テストとして記録され続ける(?admin=0で解除)
  (function initAdminMode() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.has("admin")) {
        localStorage.setItem(ADMIN_MODE_KEY, params.get("admin") === "0" ? "0" : "1");
      }
    } catch (e) { /* URLSearchParams非対応・localStorage不可の場合は通常ユーザー扱い */ }
  })();
  function isAdminMode() {
    try {
      return localStorage.getItem(ADMIN_MODE_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  /** 訪問(タブ)単位のセッションIDを取得・生成する。ファネル(閲覧→提案→カート追加→クリック)集計用 */
  function getSessionId() {
    var id;
    try {
      id = sessionStorage.getItem(SESSION_STORAGE_KEY);
      if (!id) {
        id = (window.crypto && crypto.randomUUID)
          ? crypto.randomUUID()
          : Date.now().toString(36) + Math.random().toString(36).slice(2);
        sessionStorage.setItem(SESSION_STORAGE_KEY, id);
      }
    } catch (e) {
      id = "";
    }
    return id;
  }

  // navigator.sendBeacon は広告ブロッカーにURL名と無関係に一律ブロックされることがあるため
  // 使わず、ページ遷移を伴うクリックも含めて常に fetch + keepalive で送る
  // (keepalive はページ遷移後もリクエストを継続させるための標準機能)。
  function trackEvent(type, detail, useBeacon, extra) {
    if (!eventEndpoint) return Promise.resolve();
    var base = { type: type, detail: detail || "", sessionId: getSessionId(), isAdmin: isAdminMode() };
    if (extra) {
      for (var key in extra) { if (extra.hasOwnProperty(key)) base[key] = extra[key]; }
    }
    var payload = JSON.stringify(base);
    return fetch(eventEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch(function () { /* 解析用ログの失敗はユーザー体験に影響させない */ });
  }
  // 商品ページ等から「戻る」で帰ってきた場合は新規訪問ではないため記録しない
  if (!isBackForwardNavigation()) {
    trackEvent("page_view");
  }

  // ---- 絞り込み項目(アイテムタイプ/オケージョン)の説明ポップアップ ----
  var HELP_CONTENT = {
    "about": {
      title: "AI STYLING CONCIERGE",
      body: "お手持ちの服やアクセサリーの写真をアップロードすると、AIが色・素材・テイストを分析し、似合うアクセサリーを自動で提案します。気に入ったアイテムはそのままカートに追加できます。"
    },
    "item-type": {
      title: "アイテムタイプ",
      body: "指定すると、そのタイプの商品だけに絞り込んでAIが提案します。指定しない場合は、ネックレスやイヤリングなど全タイプからバランスよく候補を選びます。"
    },
    "occasion": {
      title: "オケージョン",
      body: "指定すると、その場面(結婚式・オフィス等)に合う商品を優先的に提案します。指定しない場合は、お写真の雰囲気からAIが自動で判断します。"
    },
    "rate-limited": {
      title: "少し休憩しましょう",
      body: "短時間にたくさんご利用いただいたため、少し時間をおいてから再度お試しください。"
    }
  };
  function openHelp(key) {
    var content = HELP_CONTENT[key];
    if (!content || !helpOverlay) return;
    helpTitle.textContent = content.title;
    helpBody.textContent = content.body;
    helpOverlay.hidden = false;
  }
  function closeHelp() {
    if (helpOverlay) helpOverlay.hidden = true;
  }
  document.querySelectorAll(".ais-help-btn").forEach(function (btn) {
    // スマホはhoverが効かないため、長押しでツールチップだけ表示する(ポップアップは開かない)。
    // 通常の短いタップは今まで通りポップアップを開く。
    var longPressTimer = null;
    var longPressTriggered = false;
    btn.addEventListener("touchstart", function () {
      longPressTriggered = false;
      longPressTimer = setTimeout(function () {
        longPressTriggered = true;
        btn.classList.add("ais-help-btn--tooltip-active");
      }, 500);
    }, { passive: true });
    function clearLongPress() {
      clearTimeout(longPressTimer);
      btn.classList.remove("ais-help-btn--tooltip-active");
    }
    btn.addEventListener("touchend", clearLongPress);
    btn.addEventListener("touchcancel", clearLongPress);

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      if (longPressTriggered) {
        // 長押し(ツールチップ表示)からのクリックはポップアップを開かない
        longPressTriggered = false;
        return;
      }
      btn.classList.remove("ais-help-btn--pulse", "ais-help-btn--tooltip-active");
      openHelp(btn.dataset.help);
    });
  });
  if (helpClose) helpClose.addEventListener("click", closeHelp);
  if (helpOverlay) {
    helpOverlay.addEventListener("click", function (e) {
      if (e.target === helpOverlay) closeHelp();
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeHelp();
  });

  // ---- 画像選択(写真を選ぶ/カメラで撮る)・ドラッグ&ドロップ ----
  pickFileBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    fileInput.click();
  });
  pickCameraBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    cameraInput.click();
  });
  fileInput.addEventListener("change", function () {
    if (fileInput.files && fileInput.files[0]) handleFile(fileInput.files[0]);
  });
  cameraInput.addEventListener("change", function () {
    if (cameraInput.files && cameraInput.files[0]) handleFile(cameraInput.files[0]);
  });
  changePhotoBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    resetPhoto();
  });

  /** 選択済みの写真をクリアし、写真選択前の状態に戻す */
  function resetPhoto() {
    imageBase64 = null;
    preview.src = "";
    previewWrap.hidden = true;
    hint.hidden = false;
    submitBtn.disabled = true;
    resultsEl.hidden = true;
    hideError();
    // 同じファイルを選び直してもchangeイベントが発火するようクリアしておく
    fileInput.value = "";
    cameraInput.value = "";
    root.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  ["dragover", "dragenter"].forEach(function (t) {
    dropzone.addEventListener(t, function (e) {
      e.preventDefault();
      dropzone.classList.add("is-dragover");
    });
  });
  ["dragleave", "drop"].forEach(function (t) {
    dropzone.addEventListener(t, function (e) {
      e.preventDefault();
      dropzone.classList.remove("is-dragover");
    });
  });
  dropzone.addEventListener("drop", function (e) {
    var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    if (f) handleFile(f);
  });

  function handleFile(file) {
    if (!/^image\//.test(file.type)) {
      showError("画像ファイルを選択してください。");
      return;
    }
    hideError();
    compressToWebp(file)
      .then(function (result) {
        imageBase64 = result.base64;
        imageMediaType = result.mediaType;
        preview.src = result.dataUrl;
        previewWrap.hidden = false;
        hint.hidden = true;
        submitBtn.disabled = false;
      })
      .catch(function () {
        showError("画像の読み込みに失敗しました。別の写真でお試しください。");
      });
  }

  /** canvas で長辺768pxにリサイズし WebP(q=0.8) に変換 */
  function compressToWebp(file) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        URL.revokeObjectURL(url);
        var w = img.naturalWidth, h = img.naturalHeight;
        var scale = Math.min(1, MAX_EDGE / Math.max(w, h));
        var canvas = document.createElement("canvas");
        canvas.width = Math.round(w * scale);
        canvas.height = Math.round(h * scale);
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        var dataUrl = canvas.toDataURL("image/webp", WEBP_QUALITY);
        if (dataUrl.indexOf("data:image/webp") !== 0) {
          // WebP非対応ブラウザ(旧Safari等)は JPEG にフォールバックせずエラーにせず、そのまま送る
          dataUrl = canvas.toDataURL("image/jpeg", WEBP_QUALITY);
        }
        var mediaType = (dataUrl.match(/^data:(image\/\w+);/) || [])[1] || "image/webp";
        resolve({ dataUrl: dataUrl, base64: dataUrl.split(",")[1], mediaType: mediaType });
      };
      img.onerror = reject;
      img.src = url;
    });
  }

  // ---- 送信 ----
  // 提案取得後は、写真を変更するかアイテムタイプ/オケージョンを変更するまで
  // ボタンを再度有効化しない(同じ内容での連続クリックを防ぐ)
  occasionSel.addEventListener("change", enableSubmitIfPhotoPresent);
  if (itemTypeSel) itemTypeSel.addEventListener("change", enableSubmitIfPhotoPresent);
  function enableSubmitIfPhotoPresent() {
    if (imageBase64) submitBtn.disabled = false;
  }

  submitBtn.addEventListener("click", function () {
    if (!imageBase64 || !endpoint) {
      if (!endpoint) showError("APIエンドポイントが設定されていません。");
      return;
    }
    submitBtn.disabled = true;
    setLoading(true);
    hideError();
    resultsEl.hidden = true;

    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        image: imageBase64,
        mediaType: imageMediaType,
        occasion: occasionSel.value,
        itemType: itemTypeSel ? itemTypeSel.value : "",
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("http_" + res.status);
        return res.json();
      })
      .then(function (data) {
        renderResults(data);
        saveState(data);
        // coordinate_run の記録が完了してから coordinate_result を1件ずつ順番に送る
        // (並行に送るとスプレッドシート上での行の順序が入れ替わることがあるため)
        trackEvent("coordinate_run", data.overallComment || "", false, {
          itemType: itemTypeSel && itemTypeSel.value ? itemTypeSel.value : "指定しない",
          occasion: occasionSel.value || "指定しない",
        }).then(function () {
          var chain = Promise.resolve();
          (data.recommendations || []).forEach(function (rec) {
            chain = chain.then(function () {
              return trackEvent("coordinate_result", rec.reason || "", false, { sku: rec.product.sku || "" });
            });
          });
        });
        // 成功時はボタンを無効のままにする(写真/アイテムタイプ/オケージョン変更まで再提案させない)
      })
      .catch(function (err) {
        if (err.message === "http_429") {
          openHelp("rate-limited");
        } else {
          var msg = "提案の生成に失敗しました。時間をおいて再度お試しください。";
          if (err.message === "http_404") {
            msg = "選択されたアイテムタイプの商品が見つかりませんでした。別のタイプでお試しください。";
          }
          showError(msg);
        }
        trackEvent("error", err.message || "unknown");
        submitBtn.disabled = false; // 失敗時は再試行できるようにする
      })
      .finally(function () { setLoading(false); });
  });

  function setLoading(loading) {
    spinner.hidden = !loading;
    submitLabel.textContent = loading
      ? "お写真を拝見中…"
      : "アクセサリーを提案してもらう";
  }

  // ---- 提案状態の保存・復元(商品ページ等から「戻る」で帰ってきた際に維持する) ----
  function saveState(data) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        dataUrl: preview.src,
        occasion: occasionSel.value,
        itemType: itemTypeSel ? itemTypeSel.value : "",
        result: data,
      }));
    } catch (e) {
      // ストレージ不可・容量超過などは無視(この機能は無くても致命的ではない)
    }
  }

  function restoreState() {
    var raw;
    try {
      raw = sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return;
    }
    if (!raw) return;
    var state;
    try {
      state = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!state || !state.result || !state.dataUrl) return;

    imageBase64 = state.dataUrl.split(",")[1];
    imageMediaType = (state.dataUrl.match(/^data:(image\/\w+);/) || [])[1] || "image/webp";
    preview.src = state.dataUrl;
    previewWrap.hidden = false;
    hint.hidden = true;
    if (state.occasion) occasionSel.value = state.occasion;
    if (state.itemType && itemTypeSel) itemTypeSel.value = state.itemType;
    // この写真・条件では既に提案済みのため、条件を変えるまでボタンは無効のままにする
    submitBtn.disabled = true;
    renderResults(state.result);
  }

  // ---- 結果表示 ----
  function renderResults(data) {
    commentEl.textContent = data.overallComment || "";
    cardsEl.innerHTML = "";
    (data.recommendations || []).forEach(function (rec) {
      cardsEl.appendChild(buildCard(rec));
    });
    resultsEl.hidden = false;
    // hidden解除直後だとレイアウト確定前の古い位置でスクロール量が計算され、
    // 行き過ぎる(または足りない)ことがあるため、描画が確定してからスクロールする
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        resultsEl.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function buildCard(rec) {
    var p = rec.product;
    var card = document.createElement("article");
    card.className = "ais-card";

    function trackProductClick() {
      trackEvent("product_click", p.title, false, { sku: p.sku || "" });
    }

    if (p.image) {
      var imgLink = document.createElement("a");
      imgLink.href = p.url;
      imgLink.addEventListener("click", trackProductClick);
      var img = document.createElement("img");
      img.className = "ais-card__img";
      img.src = p.image;
      img.alt = p.title;
      img.loading = "lazy";
      imgLink.appendChild(img);
      card.appendChild(imgLink);
    }

    var body = document.createElement("div");
    body.className = "ais-card__body";

    var title = document.createElement("h3");
    title.className = "ais-card__title";
    var link = document.createElement("a");
    link.href = p.url;
    link.textContent = p.title;
    link.addEventListener("click", trackProductClick);
    title.appendChild(link);

    var price = document.createElement("div");
    price.className = "ais-card__price";
    price.textContent = formatPrice(p.price, p.currency);

    var reason = document.createElement("p");
    reason.className = "ais-card__reason";
    reason.textContent = rec.reason;

    var tipBox = document.createElement("div");
    tipBox.className = "ais-card__tip-box";
    var tipChip = document.createElement("span");
    tipChip.className = "ais-card__tip-chip";
    tipChip.textContent = "Styling Tip";
    var tip = document.createElement("p");
    tip.className = "ais-card__tip";
    tip.textContent = rec.stylingTip;
    tipBox.appendChild(tipChip);
    tipBox.appendChild(tip);

    var cartBtn = document.createElement("button");
    cartBtn.type = "button";
    cartBtn.className = "ais-card__cart";
    cartBtn.textContent = "カートに追加";
    cartBtn.addEventListener("click", function () {
      addToCart(p.variantId, cartBtn);
    });

    body.appendChild(title);
    body.appendChild(price);
    body.appendChild(reason);
    body.appendChild(tipBox);
    body.appendChild(cartBtn);
    card.appendChild(body);
    return card;
  }

  // ---- テーマ標準の「カートに追加済み」ポップアップを表示 ----
  var cartPopupOutsideClickHandler = null;

  function showThemeCartPopup(item) {
    var wrapper = document.querySelector("[data-cart-popup-wrapper]");
    if (!wrapper) return; // テーマにこのポップアップが無ければ何もしない(通常のボタン文言のみで済ませる)

    var titleEl = wrapper.querySelector("[data-cart-popup-title]");
    var quantityEl = wrapper.querySelector("[data-cart-popup-quantity]");
    var quantityLabelEl = wrapper.querySelector("[data-cart-popup-quantity-label]");
    var imageWrapper = wrapper.querySelector("[data-cart-popup-image-wrapper]");
    var cartQuantityEl = wrapper.querySelector("[data-cart-popup-cart-quantity]");
    var closeBtn = wrapper.querySelector("[data-cart-popup-close]");
    var dismissBtn = wrapper.querySelector("[data-cart-popup-dismiss]");

    if (titleEl) titleEl.textContent = item.title;
    if (quantityEl) quantityEl.textContent = String(item.quantity);
    if (quantityLabelEl) quantityLabelEl.textContent = "数量: " + item.quantity;
    if (cartQuantityEl) cartQuantityEl.textContent = String(item.cartItemCount);

    if (imageWrapper) {
      imageWrapper.innerHTML = "";
      if (item.image) {
        imageWrapper.classList.remove("hide");
        var img = document.createElement("img");
        img.src = item.image;
        img.alt = item.title;
        imageWrapper.appendChild(img);
      } else {
        imageWrapper.classList.add("hide");
      }
    }

    function hidePopup() {
      wrapper.classList.add("cart-popup-wrapper--hidden");
      if (closeBtn) closeBtn.removeEventListener("click", hidePopup);
      if (dismissBtn) dismissBtn.removeEventListener("click", hidePopup);
      if (cartPopupOutsideClickHandler) {
        document.removeEventListener("click", cartPopupOutsideClickHandler, true);
        cartPopupOutsideClickHandler = null;
      }
    }

    if (closeBtn) closeBtn.addEventListener("click", hidePopup);
    if (dismissBtn) dismissBtn.addEventListener("click", hidePopup);

    wrapper.classList.remove("cart-popup-wrapper--hidden");

    // 開いた直後の同一クリックで即座に閉じないよう、次のイベントループで外側クリック監視を開始
    cartPopupOutsideClickHandler = function (e) {
      if (!wrapper.contains(e.target)) hidePopup();
    };
    setTimeout(function () {
      document.addEventListener("click", cartPopupOutsideClickHandler, true);
    }, 0);
  }

  function formatPrice(amount, currency) {
    try {
      return new Intl.NumberFormat("ja-JP", {
        style: "currency",
        currency: currency || "JPY",
        maximumFractionDigits: 0,
      }).format(amount);
    } catch (e) {
      return "¥" + amount;
    }
  }

  /** Shopify AJAX Cart API でその場カート追加 */
  function addToCart(variantId, btn) {
    btn.disabled = true;
    btn.textContent = "追加中…";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) {
            var msg = (body && (body.description || body.message)) || ("status " + res.status);
            throw new Error(msg);
          }
          return body;
        });
      })
      .then(function (body) {
        btn.textContent = "カートに追加しました ✓";
        btn.classList.add("ais-card__cart--added");
        // テーマのカートドロワー更新イベント(対応テーマのみ)
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));

        var addedItem = (body.items && body.items[0]) || body;
        trackEvent("cart_add", addedItem.product_title || addedItem.title || "", false, { sku: addedItem.sku || "" });
        return fetch("/cart.js")
          .then(function (res) { return res.json(); })
          .catch(function () { return null; })
          .then(function (cart) {
            showThemeCartPopup({
              title: addedItem.product_title || addedItem.title,
              image: addedItem.featured_image ? addedItem.featured_image.url : null,
              quantity: addedItem.quantity,
              cartItemCount: cart ? cart.item_count : addedItem.quantity,
            });
          });
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = "カートに追加";
        console.error("cart/add.js error:", err.message, "variantId:", variantId);
        showError("カートへの追加に失敗しました: " + err.message);
      });
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }
  function hideError() {
    errorEl.hidden = true;
  }

  /** 「戻る/進む」でのページ表示かどうかを判定(明示的なリロードでは状態を復元させないため) */
  function isBackForwardNavigation() {
    try {
      var entries = performance.getEntriesByType("navigation");
      if (entries && entries.length > 0) {
        return entries[0].type === "back_forward";
      }
    } catch (e) { /* 未対応ブラウザは下のフォールバックへ */ }
    try {
      // 非推奨だが未対応ブラウザ向けのフォールバック(2 = TYPE_BACK_FORWARD)
      if (performance.navigation && performance.navigation.type === 2) return true;
    } catch (e) { /* 判定不可の場合は false 扱い(=リロードと同様、状態を復元しない) */ }
    return false;
  }

  if (isBackForwardNavigation()) {
    restoreState();
  }
})();
